const COLOURS = {
    RED: "#D25D48",
    BLUE: "#4799B2",
    DARK_BLUE: "#00566F",
    YELLOW: "#E5A120",
    GREEN: "#22905D"
}

export default COLOURS;